export default __webpack_public_path__ + "static/recog-5-7bf0b5a9a543dc8eca8a44f93865192d.webp";